module.exports = __webpack_public_path__ + "img/bjt.720c7052.png";